import React, { ReactNode, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

declare global {
  interface Window {
    DD_RUM?: {
      startView: (viewName: string) => void
    }
  }
}

export const RumRoute = ({ children }: { children: ReactNode }) => {
  const location = useLocation()
  useEffect(() => {
    window.DD_RUM?.startView('/catering/?' + location.pathname)
  }, [location.pathname])
  return <>{children}</>
}
